const getCurrentDateInISOWithTimezone = () => {
  const date = new Date();

  // Get components of the local date and time
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Get the timezone offset in minutes and convert to hours and minutes
  const timezoneOffset = -date.getTimezoneOffset();
  const absOffsetHours = String(
    Math.trunc(Math.abs(timezoneOffset) / 60),
  ).padStart(2, '0');
  const absOffsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(
    2,
    '0',
  );

  // Determine the sign of the timezone offset
  const sign = timezoneOffset >= 0 ? '+' : '-';

  // Construct final ISO string with timezone offset
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${absOffsetHours}:${absOffsetMinutes}`;
};

export default getCurrentDateInISOWithTimezone;
